import { render, staticRenderFns } from "./escuelasAsesor.vue?vue&type=template&id=5211741a"
import script from "./escuelasAsesor.vue?vue&type=script&lang=js"
export * from "./escuelasAsesor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports